import { bp as Re, bF as Z, bq as we, bS as Ke, bR as Pe, bs as He, br as ke, bt as m, bu as s, bD as ze } from "./helpers-458d7e27.js";
import { forwardRef as We, useMemo as Ue, useRef as Ve, useState as ee, useEffect as $e } from "react";
import { CriticalIcon as Xe, ChevronUpIcon as qe, ChevronDownIcon as Ge } from "@paypalcorp/pp-react-icons";
import { useTheme as Je, jsx as c, css as p } from "@emotion/react";
import "react/jsx-runtime";
import "clsx";
import "@paypalcorp/pp-react-theme";
import "react-dom";
var ce, ue, de, me, pe, be, fe, ve, ge, he, ye, Ce;
function Qe(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var l = e.sysMotionDurationHover, n = e.sysSizeIconSm, o = e.sysSizeFieldLg, v = e.sysColorBackgroundSurface, b = e.sysBorderThicknessNormal, B = e.sysBorderRadiusSm, U = e.sysColorStructureBorderHighContrast, A = e.sysSpaceTiny, C = e.sysSpaceXs, g = e.sysSpaceSm, r = e.sysSpaceMd, E = e.sysColorBackgroundMediumContrast, _ = e.sysTypographyFieldLabelLgLineHeight, I = e.sysTypographyFieldLabelSmLineHeight, u = e.sysBorderThicknessEmphasis, D = He(e), h = D.focusStyles, T = D.ellipsis, R = h.offsetFocusAfter, O = h.stateErrorFocusBorderColorInner, x = h.stateErrorFocusBorderColorOuter, S = ke(e), i = S.fieldLabelLg, K = S.fieldValueSm, P = S.fieldLabelSm, j = S.caption, H = p(ce || (ce = m([`
    label: dropdown_menu_base;
    position: relative;
    text-align: start;
  `]))), k = p(ue || (ue = m([`
    label: dropdown_menu_label;
    pointer-events: none; // Better way to fix the cursor: text issue!
    position: absolute;
    `, `
    transition: font-size `, " ease-in-out, top ", " ease-in-out, background-color ", ` linear;
    left: `, `;
    top: `, `;
    `, `
    right: `, `;

    [dir='rtl'] & {
      right: `, `;
      left: `, `;
    }
  `])), i(), l, l, l, r, s("(".concat(o, " - ").concat(_, ") / 2")), T, s("".concat(r, " + ").concat(n)), r, s("".concat(r, " + ").concat(n))), F = p(de || (de = m([`
    label: active;
    outline: none;
    &:after {
      `, `
    }
  `])), R({
    height: o,
    horizontalOffset: "0rem",
    verticalOffset: "0rem"
  })), V = p(me || (me = m([`
    label: dropdown_menu_button;
    `, `;
    box-sizing: border-box;
    height: `, `;
    width: 100%;
    border: `, ` solid
      `, `;
    border-radius: `, `;
    background-color: `, `;
    padding-top: `, `;
    padding-right: `, `;
    padding-left: `, `;
    padding-bottom: `, `;
    cursor: pointer;
    text-align: start;
    `, `

    &:focus {
      `, `
    }

    [dir='rtl'] & {
      padding-left: `, `;
      padding-right: `, `;
    }
  `])), K(), o, b, U, B, v, s("".concat(g, " + ").concat(A, " + ").concat(I, " - ").concat(b)), s("".concat(r, " + ").concat(n, " - ").concat(b)), s("".concat(r, " - ").concat(b)), s("".concat(r, " - ").concat(b)), T, F, s("".concat(r, " + ").concat(n, " - ").concat(b)), s("".concat(r, " - ").concat(b))), z = p(pe || (pe = m([`
    label: active;
    &:after {
      `, `
    }
  `])), R({
    height: o,
    horizontalOffset: "0rem",
    verticalOffset: "0rem",
    borderColor: O,
    boxShadowColor: x
  })), $ = p(be || (be = m([`
    label: error;
    border: `, ` solid
      `, `;
    padding-top: `, `;
    padding-right: `, `;
    padding-left: `, `;
    padding-bottom: `, `;

    &:focus {
      `, `
    }

    [dir='rtl'] & {
      padding-left: `, `;
      padding-right: `, `;
    }
  `])), u, O, s("".concat(g, " + ").concat(A, " + ").concat(I, " - ").concat(u)), s("".concat(r, " + ").concat(n, " - ").concat(u)), s("".concat(r, " - ").concat(u)), s("".concat(r, " - ").concat(u)), z, s("".concat(r, " + ").concat(n, " - ").concat(u)), s("".concat(r, " - ").concat(u))), W = p(fe || (fe = m([`
    label: active;
    `, `
    top: `, `;
  `])), P(), g), d = p(ve || (ve = m([`
    label: dropdown_menu_affordance_icon;
    pointer-events: none;
    position: absolute;
    top: `, `;
    right: `, `;
    margin-left: `, `;

    [dir='rtl'] & {
      margin-right: `, `;
      left: `, `;
      right: auto;
    }
  `])), s("".concat(g, " + ").concat(r)), s("".concat(g, " + ").concat(r)), r, r, g), y = p(ge || (ge = m([`
    label: dropdown_menu_helper_text;
    `, `
    margin-top: `, `;
    list-style: none; // In case it's a list of helper texts
  `])), j({
    color: E
  }), C), X = p(he || (he = m([`
    label: dropdown_menu_error_text;
    `, `
    display: flex;
    margin-top: `, `;
    align-items: center;
  `])), j({
    color: E
  }), C), N = p(ye || (ye = m([`
    label: dropdown_menu_error_icon;
    color: `, `;
    margin-right: `, `;

    [dir='rtl'] & {
      margin-left: `, `;
      margin-right: 0;
    }
  `])), O, C, C), q = p(Ce || (Ce = m([`
    label: dropdown_menu_select;
    opacity: 0;
    position: absolute;
    pointer-events: none;
    width: 0;
    height: 0;
  `])));
  return {
    base: H,
    label: k,
    button: V,
    buttonError: $,
    buttonActive: F,
    buttonErrorActive: z,
    affordanceIcon: d,
    labelActive: W,
    helperText: y,
    errorText: X,
    errorIcon: N,
    selectBox: q
  };
}
var Ye = ["className", "menuContainerClassName", "menuListClassName", "menuItemClassName", "menuMobileHeaderClassName", "menuButtonClassName", "menuLabelClassName", "skipButtonFocus", "sheetClassName", "sheetWrapperClassName", "id", "label", "name", "errorText", "errorIconAriaLabel", "helperText", "value", "options", "ariaLabelledby", "renderButtonContent", "onChange", "onClose", "onClick", "onKeyDown", "isLoadingOptions", "showUnselect"];
function _e(e, l) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    l && (o = o.filter(function(v) {
      return Object.getOwnPropertyDescriptor(e, v).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function te(e) {
  for (var l = 1; l < arguments.length; l++) {
    var n = arguments[l] != null ? arguments[l] : {};
    l % 2 ? _e(Object(n), !0).forEach(function(o) {
      ze(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _e(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
var Se = function(e) {
  return (
    /* istanbul ignore next */
    e && e.current ? e.current : null
  );
}, Ze = function(e, l, n, o, v) {
  if (e) {
    var b = {
      css: v.errorIcon,
      role: "img",
      "aria-label": l
    }, B = c(Xe, we({
      size: "sm"
    }, b, {
      "data-ppui": "true"
    }));
    return c("div", {
      css: v.errorText,
      id: o,
      "data-ppui": "true"
    }, B, c("span", {
      "data-ppui": "true"
    }, e));
  }
  return n ? c("div", {
    css: v.helperText,
    id: o,
    "data-ppui": "true"
  }, c("span", {
    "data-ppui": "true"
  }, n)) : null;
}, et = function(e) {
  return !e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey;
}, ct = We(
  // eslint-disable-next-line complexity
  function(e, l) {
    var n = e.className, o = e.menuContainerClassName, v = e.menuListClassName, b = e.menuItemClassName, B = e.menuMobileHeaderClassName, U = e.menuButtonClassName, A = e.menuLabelClassName, C = e.skipButtonFocus, g = C === void 0 ? !1 : C, r = e.sheetClassName, E = e.sheetWrapperClassName, _ = e.id, I = e.label, u = I === void 0 ? "Label" : I, D = e.name, h = e.errorText, T = e.errorIconAriaLabel, R = T === void 0 ? "Error" : T, O = e.helperText, x = e.value, S = e.options, i = S === void 0 ? [] : S, K = e.ariaLabelledby, P = e.renderButtonContent, j = e.onChange, H = e.onClose, k = e.onClick, F = e.onKeyDown, V = e.isLoadingOptions, z = e.showUnselect, $ = Re(e, Ye), W = Je(), d = Ue(function() {
      return Qe(W);
    }, [W]), y = _ ? "dropdownMenuButton_".concat(_) : "dropdownMenuButton_".concat(u.replace(/\s/g, "")), X = Ve(), N = l ?? X, q = _ ? "dropdownMenuSelect_".concat(_) : "dropdownMenuSelect_".concat(u.replace(/\s/g, "")), Oe = ee(!1), ne = Z(Oe, 2), w = ne[0], G = ne[1], xe = ee(!!x), ae = Z(xe, 2), Ne = ae[0], Le = ae[1], Be = ee(!1), re = Z(Be, 2), Ie = re[0], Te = re[1];
    $e(function() {
      var a, t = Se(N), f = t && ((a = window) === null || a === void 0 ? void 0 : a.getComputedStyle(t));
      Te((f == null ? void 0 : f.direction) === "rtl");
    });
    var oe = function(a) {
      G(function(t) {
        return !t;
      }), Le(!a.detail);
    }, le = function(a) {
      G(!1);
      var t = Se(N);
      t && (g ? t.blur() : t.focus());
      var f;
      if (j) {
        var ie = i.length > 0 && a >= 0;
        f = ie ? i[a].value || i[a].primaryText : null, z && (f = ie ? i[a].value : null);
        var De = {
          target: {
            selectedIndex: a,
            value: f
          }
        };
        j(De);
      }
    }, J = O && "dropdown_helperText" || h && "dropdown_errorText", M = "", se = "", Q = -1;
    if (x) {
      for (var L = 0; L < i.length; L++)
        if (i[L].value === x) {
          P ? M = P() : M = i[L].primaryText, se = i[L].value, Q = L;
          break;
        }
    } else
      !x && i.length > 0 && i[0].value === "" && (Q = 0);
    var je = w ? qe : Ge, Fe = c(je, {
      size: "sm",
      css: d.affordanceIcon,
      color: "BackgroundMediumContrast",
      "aria-hidden": "true",
      "data-ppui": "true"
    }), Y = K ? "".concat(y, "-label ").concat(K) : "".concat(y, "-label");
    M && (Y = "".concat(Y, " ").concat(y));
    var Me = te(te(te({}, J && {
      "aria-describedby": J
    }), {
      "aria-labelledby": Y
    }), $), Ae = [d.button, w && d.buttonActive, h && d.buttonError, h && w && d.buttonErrorActive], Ee = [d.label, (w || M) && d.labelActive];
    return c("div", {
      className: n,
      css: d.base,
      id: _,
      "data-ppui-info": "dropdown-menu_3.4.4"
    }, c("select", {
      css: d.selectBox,
      "aria-hidden": "true",
      id: q,
      name: D,
      tabIndex: -1,
      onChange: function(a) {
        return le(a.target.selectedIndex - 1);
      },
      value: se,
      "data-ppui": "true"
    }, c("option", {
      disabled: !0,
      value: "",
      "data-ppui": "true"
    }, u), i.length > 0 && i.map(function(a, t) {
      return c("option", {
        key: t,
        value: a.value ? a.value : a.primaryText,
        "data-ppui": "true"
      }, a.primaryText);
    })), c("button", we({
      className: U,
      css: Ae,
      type: "button",
      id: y,
      ref: N,
      "aria-haspopup": "listbox",
      "aria-expanded": w,
      onClick: function(t) {
        oe(t), k && k(t);
      },
      onKeyDown: function(t) {
        var f = new Ke(t.key || t.keyCode);
        !w && (f.IS_ARROW_UP || f.IS_ARROW_DOWN) && et(t) && (t.preventDefault(), oe(t)), F && F(t);
      }
    }, Me, {
      "data-ppui": "true"
    }), Fe, c("span", {
      "data-ppui": "true"
    }, M)), c("label", {
      id: "".concat(y, "-label"),
      htmlFor: y,
      css: Ee,
      className: A,
      "data-ppui": "true"
    }, c("span", {
      "data-ppui": "true"
    }, u)), c(Pe, {
      initialItemFocus: Ne,
      isOpen: w,
      mobileTitle: u,
      onClose: function(t) {
        G(!1), H && H(t);
      },
      onSelection: le,
      selectedIndex: Q,
      triggerElementRef: N,
      options: i,
      className: v,
      containerClassName: o,
      itemClassName: b,
      mobileHeaderClassName: B,
      sheetClassName: r,
      sheetWrapperClassName: E,
      rtl: Ie,
      returnFocusToTrigger: !g,
      isLoadingOptions: V,
      searchEnabled: !0,
      "data-ppui": "true"
    }), Ze(h, R, O, J, d));
  }
);
export {
  ct as PpReactDropdownMenu
};
//# sourceMappingURL=PpReactDropdownMenu.js.map
